import { render, staticRenderFns } from "./EventsIndex.vue?vue&type=template&id=6b556ccb"
import script from "./EventsIndex.vue?vue&type=script&lang=js"
export * from "./EventsIndex.vue?vue&type=script&lang=js"
import style0 from "./EventsIndex.vue?vue&type=style&index=0&id=6b556ccb&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports